/*
 * Mark ONLY scroll-performance events (touch / wheel / scroll) as passive.
 *
 * This replaces `import 'default-passive-events'`, whose default event list
 * also includes `mousedown` / `mouseup`. Forcing those passive broke Vuetify
 * 1.5 dropdown selection: VSelectList relies on a `mousedown` handler that
 * calls `preventDefault()` to keep the input focused while you click an
 * option. Once `mousedown` is passive, `preventDefault()` is ignored, the
 * field blurs before the click lands, and the option is never selected — the
 * "v-autocomplete / v-select selection clears the moment you click it" bug
 * (e.g. the personal-voucher passenger picker and the create-booking driver
 * picker). Keyboard selection kept working, which is the tell-tale sign.
 *
 * We still want the passive optimisation (and to silence Chrome's
 * "non-passive scroll-blocking listener" warnings from mapbox-gl / google
 * maps), so we keep it for the events where it actually matters and leave all
 * mouse-button events alone.
 */
const PASSIVE_TYPES = ['scroll', 'wheel', 'mousewheel', 'touchstart', 'touchmove'];

function passiveSupported() {
  let supported = false;
  try {
    const opts = Object.defineProperty({}, 'passive', {
      get() { supported = true; return undefined; },
    });
    window.addEventListener('test-passive', null, opts);
    window.removeEventListener('test-passive', null, opts);
  } catch (e) {
    supported = false;
  }
  return supported;
}

if (typeof EventTarget !== 'undefined' && passiveSupported()) {
  const original = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function (type, listener, options) {
    if (PASSIVE_TYPES.indexOf(type) !== -1) {
      const isObject = typeof options === 'object' && options !== null;
      const capture = isObject ? options.capture : options;
      options = isObject ? options : {};
      if (options.passive === undefined) options.passive = true;
      options.capture = capture === undefined ? false : capture;
    }
    return original.call(this, type, listener, options);
  };
}
